var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00001 7.19996L2.50001 4.69996C2.11341 4.31336 1.48661 4.31336 1.10001 4.69996C0.713409 5.08656 0.713409 5.71336 1.10001 6.09996L4.2929 9.29285C4.68343 9.68338 5.31659 9.68338 5.70712 9.29285L13.3 1.69996C13.6866 1.31336 13.6866 0.686559 13.3 0.299959C12.9134 -0.0866401 12.2866 -0.0866401 11.9 0.299959L5.00001 7.19996Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.210e1a66a36fece818a4d8f2de1a4347.svg";
export { ForwardRef as ReactComponent };